import { HsaFsaScreen } from '../../../screens/HsaFsaScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <HsaFsaScreen />;
}
